import { useEffect, useState } from 'react';
import { getWebSettingsByBusiness, getWebSettingsByBranch } from '../api/webSettingsApi';

const DEFAULT_WEB_SETTINGS = {
    businessId: '',
    buttonColors: {
        buttonColor: '#0A84FF',
        appbarColor: '#0A84FF',
        priceColor: '#10B981',
    },
    theme: 'THEME1',
    showPriceProduct: true,
    showGrossPrice: false,
    freeDelivery: false,
    paidDelivery: false,
    deliveryPrice: 0,
    showClickPay: true,
    showOfflinePay: true,
    clickService: null,
    clickMerchat: null,
    secretKey: null,
    subscription: true,
    productSale: true,
    bronQilish: false,
    offCount: true,
};

/**
 * webSettings ni yuklaydi:
 * - agar businessId bo‘lsa: biznes bo‘yicha
 * - aks holda branch bo‘yicha
 * Kesh muammolari uchun cache-bust qo‘shilgan.
 */
export function useWebSettings({ businessId, branchId }) {
    const [webSettings, setWebSettings] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // businessId/branchId yo‘q bo‘lsa chaqirmaymiz
        if (!businessId && !branchId) {
            setWebSettings(null);
            return;
        }

        const controller = new AbortController();

        (async () => {
            try {
                setLoading(true);

                // 1) Biznes bo‘yicha ustunroq bo‘lsin
                let data = null;
                if (businessId) {
                    data = await getWebSettingsByBusiness(businessId, {
                        signal: controller.signal,
                        cacheBust: true,
                    });
                } else if (branchId) {
                    data = await getWebSettingsByBranch(branchId, {
                        signal: controller.signal,
                        cacheBust: true,
                    });
                }

                // Yaxshi default’lar bilan merge qilamiz
                setWebSettings({ ...DEFAULT_WEB_SETTINGS, ...(data || {}) });
            } catch (e) {
                console.warn('web-settings load failed:', e);
                // Hatolik bo‘lsa ham UI yiqilmasin
                setWebSettings({ ...DEFAULT_WEB_SETTINGS });
            } finally {
                setLoading(false);
            }
        })();

        return () => controller.abort();
    }, [businessId, branchId]);

    return { webSettings, loading };
}
